import React from 'react';
import moment from 'moment-timezone';
import styled from 'styled-components';

const Span = styled.span`
    font-weight: 300;
`;

interface IProps {
    timestamp: string;
}
const Timestamp = ({
  timestamp,
}: IProps) => {
  const time = moment(timestamp).format('HH:mm');
  const date = moment(timestamp).format('MMM DD YYYY');
  if (time.toLocaleLowerCase() === 'invalid date') {
    return <>-</>;
  }
  return (
    <Span>
      {time}
      ,
      {' '}
      {date}
    </Span>
  );
};

export default Timestamp;
